import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import CloseIcon from "../../media/images/CloseIcon.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix="PeriGanttNodeInfo";

const NodeInfoLine = class extends Component {
	render() {
		if ( ! this.props.label || ! this.props.value ) return null;
		return (
			<div className={"line"} key={this.props.key}>
				<span>{ this.props.label}</span>
				{ this.props.onClick ? (
					<div style={{cursor:"pointer"}} onClick={ this.props.onClick }>
						{ this.props.value }
					</div>
				) : (
					<div>{ this.props.value }</div>
				)}
			</div>
		)
	}
}

const PeriGanttNodeInfo = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			x: 10 + 20 * (props.index || 0),
			y: 10 + 35 * (props.index || 0)
		};
		this.uid = Glob.generateUid(prefix);
		this.status = this.status.bind(this);
		this.statusValue = this.statusValue.bind(this);
		this.historySteps = this.historySteps.bind(this);
	}
	statusValue( status ) {
		if ( ! status || typeof status !== 'object') return null;
		const keys = Object.keys(status);
		const v = ['c','i','a','o'].filter( k => keys.includes(k)).map( k => (
			<div key={k}><em>{ k }</em><strong>{ parseInt(status[k] * 100)}</strong></div>
		));
		return v.length ? v : null;
	}
	status() {
		const v = this.statusValue(this.props.node.status);
		if ( ! v ) return null;
		return <NodeInfoLine label={"⚠️"} value={v} />;
	}
	historySteps() {
		const h = this.props.node.history;
		if ( ! Array.isArray(h) ) return null;
		return h.map( (entry, idx) => {
			const v = this.statusValue(entry.status);
			return [
				<div key={"separator"} className={"historySeparator"} hidden={!idx} />,
				( v ? <NodeInfoLine key={"status"} label={"⚠️"} value={v} /> : null ),
				<NodeInfoLine key={"name"} label={"Name"} value={entry.label} />,
				<NodeInfoLine key={"after"} label={"After"} value={entry.delayLabel} />,
				<NodeInfoLine key={"by"} label={"By"} value={entry.byLabel} onClick={ ()=>{ this.props.another(entry.by) }} />,
			];
		});
	}
	render() {
		return (
			<div
				id={ this.uid }
				className={prefix}
				style={{top: `${ this.state.y }px`,left: `${ this.state.x }px`}}
				onMouseDown={ ()=>{
					const me = window.document.getElementById(this.uid);
					me.parentNode.querySelectorAll('div.'+prefix).forEach( n => {
						n.style.removeProperty('z-index');
					});
					me.style.zIndex = 20;
				}}
				onDoubleClick={ ()=>{
					const me = window.document.getElementById(this.uid);
					me.style.removeProperty('width');
					me.style.removeProperty('height');
				}}
				onContextMenu={ e => {
					e.preventDefault();
					e.stopPropagation();
					this.props.select();
				}}
			>
				<div className={"title"}>
					<div
						onMouseDown={ e=>{
							const element = window.document.getElementById(this.uid);
							appLib.dragging( element,e.clientX - element.offsetLeft,e.clientY - element.offsetTop );
						}}
						onMouseUp={ () =>{
							const element = window.document.getElementById(this.uid);
							this.setState({
								x: element.offsetLeft,
								y: element.offsetTop
							}, ()=>{ appLib.dragging(false); } )
						}}
						title={ this.props.node.label }
					>
						{ this.props.node.label }
					</div>
					<span onClick={ this.props.close }>
						<CloseIcon />
					</span>
				</div>
				<div className={"body"}>
					{ this.historySteps() }
				</div>
			</div>
		)
	}
}

export default PeriGanttNodeInfo;